<template>
  <div class="activeEdit">
    <div class="backBox">
      <img
        class="pointer"
        @click="handleBack()"
        src="@/assets/thdImg/pages/back.svg"
        alt=""
      />
      <span class="backBox_name">{{ activityData.title }}</span>
    </div>
    <div class="fixBox">
      <!-- 步骤条 -->
      <div class="stepBox">
        <el-steps
          class="bz"
          :space="300"
          :active="0"
        >
          <el-step title="活动模板"></el-step>
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>
      <!--  -->
      <div
        class="activeEdit_bottom"
        v-loading="loading"
      >
        <div class="template">
          <div style="width: 75px;padding-top: 5px;">模板类型：</div>
          <div class="template-nav">
            <div
              class="template-wz pointer"
              v-for="(item, index) in tempSwitchList"
              :key="item.id"
              :class="{ activeTem: index == tempIndex }"
              v-show="item.isVisible"
              @click="sellerImage(item.id, index,item.title)"
            >
              {{ item.title }}
            </div>
          </div>
        </div>
        <!-- m模板图 -->
        <div class="templateBox">
          <!-- 定制 -->
          <div
            class="temImg"
            v-if="customUploadList.includes(Number($route.query.activityType)) && tempTitle == '自定义上传'"
          >
            <div
              class="temImg_content"
              @click="handleTemDialog('new')"
              style="border: 1px solid rgba(38,112,251,0.5000);"
            >
              <div class="temImg_content_img temImg_dz">
                <div class="temImg_dz_center">
                  <img
                    src="@/assets/thdImg/pages/upTem.svg"
                    alt=""
                  />
                  <span style="text-align: center;margin:0">上传模板</span>
                </div>
              </div>
              <div
                class="temImg_content_wz"
                style="background: rgba(38, 112, 251, 0.05);"
              ></div>
            </div>
          </div>
          <div
            class="temImg"
            v-else
          >
            <div
              class="temImg_content"
              @click="handleOpen()"
              style="border: 1px solid rgba(38,112,251,0.5000);"
            >
              <div class="temImg_content_img temImg_dz">
                <div class="temImg_dz_center">
                  <img
                    src="@/assets/thdImg/pages/dz.svg"
                    alt=""
                  />
                  <span>品牌定制</span>
                </div>
              </div>
              <div
                class="temImg_content_wz"
                style="background: rgba(38, 112, 251, 0.05);"
              ></div>
            </div>
          </div>
          <!-- 模板 -->
          <div
            class="temImg"
            v-for="item in giftList"
            :key="item.templateId"
          >
            <div class="temImg_content">
              <div class="temImg_content_img">
                <img
                  class="imgs"
                  style="width:100%;"
                  :src="activityTypeList.includes(Number($route.query.activityType || copyParams.activityType)) ? $route.query.activityType == 8 || $route.query.activityType == 19 || copyParams.activityType == 8 || copyParams.activityType == 19 ?  item.fourPictureUrl : (copyParams.activityType == 37 ||  $route.query.activityType == 37)  ? item.eightPictureUrl: item.thankImageUrl : item.templateExampleUrl"
                  alt=""
                />
                <img
                  v-if="item.days"
                  class="temImg_content_img_free"
                  src="@/assets/images/free.svg"
                  alt=""
                  srcset=""
                />
                <div
                  v-if="item.days"
                  class="temImg_content_img_time"
                >倒计时：{{ item.days }}</div>
              </div>
              <div class="temImg_content_wz">
                <span class="temImg_title">{{ activityTypeList.includes(Number($route.query.activityType || copyParams.activityType)) ? item.imageName : item.templateName }}</span>
                <span class="temImg_desc">模板ID：{{ item.templateId }}</span>
              </div>
            </div>
            <!-- hover -->
            <div class="temImg_content_bgshadow">
              <div
                class="temImg_content_bgshadow_code qrCodeIMG"
                id="qrCodeIMG1"
                ref="qrCodeIMG1"
                :style="customUploadList.includes(Number($route.query.activityType)) && tempTitle == '自定义上传'?'margin-top: 60px;':''"
              ></div>
              <div class="temImg_content_bgshadow_codeDesc">手机扫码预览模板</div>
              <div
                class="temImg_content_bgshadow_btn pointer"
                @click="handleSet(item, 2)"
                :style="customUploadList.includes(Number($route.query.activityType)) && tempTitle == '自定义上传'?'width: 136px;':''"
              >使用此模板</div>
              <!-- 自定义上传 -->
              <div
                v-if="customUploadList.includes(Number($route.query.activityType)) && tempTitle == '自定义上传'"
                class="temImg_content_bgshadow_editBtns"
              >
                <div
                  class="temImg_content_bgshadow_edit pointer"
                  @click="handleTemDialog('edit',item)"
                >编辑模板</div>
                <div
                  class="temImg_content_bgshadow_edit pointer"
                  @click="deleteTemDialog(item)"
                >删除模板</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <templateDialog
      v-if="isTemplateDialog"
      :isShow="isTemplateDialog"
      :activityType="Number($route.query.activityType)"
      :templateDialogType="templateDialogType"
      :temId="temId"
      :templateGroupId="templateGroupId"
      @onSave="saveTemplate"
      @onClose="isTemplateDialog = false"
    ></templateDialog>
  </div>
</template>

<script>
import Back from "./back.vue";
import giftTmp from "../../mixin/giftTmp.js";
import templateDialog from "@/components/templateDialog.vue"
export default {
  name: "activeEdit",
  mixins: [giftTmp],
  components: {
    Back,
    templateDialog
  },

  props: {
    copyParams: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data () {
    return {
      // tempIndex: 0,
      // tempSwitchList: ["全部", "618", "双11", "双12"],
    };
  },
  created () {
    setTimeout(() => {
      if (sessionStorage.getItem("goBack")) sessionStorage.removeItem("goBack");
    });
    this.$nextTick(() => {
      this.getCodeIMG1();
    });
  },
  methods: {
    handleBack () {
      this.$emit("goBack");
    },
  },
};
</script>

<style lang="scss" scoped>
.activeEdit {
  // width: 98%;
  // margin: 24px;
  // padding: 24px;
  // min-height: 1062px;
  background: #ffffff;
  // .fixBox {
  //   height: 759px;
  // }
  &_bottom {
    .template {
      display: flex;
      color: #333333;
      // align-items: center;
      margin-bottom: 16px;
      &-nav {
        display: flex;
        flex-wrap: wrap;
      }
      &-wz {
        padding: 4px 8px;
        color: #666666;
        background: #f8f8fb;
        border-radius: 4px;
        margin-left: 12px;
        margin-bottom: 10px;
        &:hover {
          background: #2670fb;
          border-radius: 4px;
          color: #ffffff;
        }
      }
      .activeTem {
        background: #2670fb;
        border-radius: 4px;
        color: #ffffff;
      }
    }
    .templateBox {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
    }
    .temImg {
      width: 224px;
      height: 453px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      margin-right: 41px;

      &:hover .temImg_content_bgshadow {
        opacity: 0;
        animation: key3 0.5s forwards;
      }
      @keyframes key3 {
        0% {
          opacity: 0;
        }
        50% {
          opacity: 0.3;
        }
        100% {
          opacity: 1;
        }
      }
      .temImg_content_bgshadow {
        z-index: 123;
        opacity: 0;
        position: absolute;
        // left: -1;
        top: 10px;
        width: 100%;
        height: 380px;
        background: rgba(0, 0, 0, 0.7);
        border-radius: 8px 8px 0px 0px;
        transform: scale(1.05);
        &_code {
          margin: 0 auto;
          margin-top: 125px;
          width: 150px;
          height: 150px;
          background: #ffffff;
          border-radius: 4px;
        }
        &_codeDesc {
          margin: 0 auto;
          margin-top: 15px;
          width: 112px;
          color: #ffffff;
        }
        &_btn {
          margin: 0 auto;
          margin-top: 25px;
          margin-bottom: 8px;
          width: 86px;
          height: 32px;
          line-height: 32px;
          text-align: center;
          background: #2670fb;
          border-radius: 4px;
          color: #ffffff;
        }
        &_editBtns {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 136px;
          margin: 0 auto;
        }
        &_edit {
          margin: 0 auto;
          width: 64px;
          height: 28px;
          line-height: 28px;
          text-align: center;
          font-weight: 400;
          font-size: 12px;
          color: #2670fb;
          background: #ffffff;
          border-radius: 4px 4px 4px 4px;
        }
      }
      &_content {
        width: 100%;
        height: 433px;
        box-sizing: border-box;
        background: #ffffff;
        border-radius: 8px;
        border: 1px solid #dcdfe6;
        transition: 0.6s linear;
        &_img {
          width: 100%;
          height: 380px;
          border-radius: 8px 8px 0px 0px;
          background: rgba(38, 112, 251, 0.05);
          // transition: 0.6s linear;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        &_wz {
          width: 100%;
          height: 53px;
          padding: 10px 12px;
        }
      }

      &:hover {
        .temImg_content {
          box-shadow: 0px 12px 25px 1px rgba(0, 0, 0, 0.15);
          border-radius: 8px;
          transform: scale(1.05);
          transition: transform 0.3s, -webkit-transform 0.3s;
        }
      }
      &_dz {
        width: 100%;
        // height: 433px;
        display: flex;
        justify-content: center;
        align-items: center;
        &_center {
          > img {
            margin: 0 auto;
            display: block;
          }
          > span {
            font-size: 20px;
            font-weight: bold;
            margin-top: 12px;
            display: block;
          }
        }
      }
      &_title {
        display: block;
        color: #333333;
      }
      &_desc {
        display: block;
        font-size: 12px;
        line-height: 23px;
        color: #999;
      }
    }
    @media screen and (min-width: 1350px) and (max-width: 1700px) {
      .temImg {
        margin-right: 26px !important;
      }
    }
  }
}
</style>
